
import { RevButton } from '@ds/components/Button'
import { RevDivider } from '@ds/components/Divider'
import { RevRating } from '@ds/components/Rating'
import { IconQuality } from '@ds/icons/IconQuality'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { fetchProductRateDistribution } from '@http/endpoints'
import { TRACKING_ZONE } from '@internal-reviews/components/Page/constants'
import ReviewsLegalModal from '@internal-reviews/components/ReviewsLegalModal'
import UserComment from '@internal-reviews/components/UserComment'
import RateFilter from '@internal-reviews/components/legacy/RateFilter'
import { logReviewsError } from '@reviews/helpers'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import translations from './ReviewsBlock.translations'

export default {
  components: {
    IconQuality,
    RateFilter,
    RevRating,
    RevButton,
    RevDivider,
    UserComment,
    ReviewsLegalModal,
  },
  props: {
    averageRate: {
      type: Number,
      required: true,
    },
    reviewsCount: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rateDistribution: [],
    }
  },
  computed: {
    translations: () => translations,
    shouldDisplayCta() {
      return this.reviewsCount > 1
    },
    reviewTrackingInfo() {
      return {
        ...this.trackingInfo,
        averageRate: this.averageRate,
        pageType: this.$route.name,
      }
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  async mounted() {
    this.watchReviewInViewport()

    const [{ payload: rateDistribution }] = await Promise.all([
      await this.$store
        .dispatch('http/request', {
          request: fetchProductRateDistribution,
          pathParams: { productId: this.productId },
          // [COM-362] TODO to remove withReviewTranslation when it is done on BE side
          queryParams: { withReviewTranslation: true },
        })
        .catch((err) => {
          logReviewsError({ tags: ['ProductPage'], err })

          return { payload: {} }
        }),
    ])

    this.rateDistribution = rateDistribution.statsInfo || []
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression(this.reviewTrackingInfo)
      })
    },
    displayDivider(index) {
      return index < this.reviews.length - 1
    },
    trackReviews() {
      trackClick({
        zone: TRACKING_ZONE,
        name: 'see_all_reviews',
        pageType: this.$route.name,
      })
    },
  },
}
